<template lang="pug">
.report 
  WebTemplate(
    pagetitle= "来源分析",
    tip= "本报告帮助您了解您网站流量来源的组成，从直接访问、搜索引擎和外部链接三个方面帮助您深入分析流量分布。助您有效管理网络推广渠道，合理优化推广方案",
    :currentTab= "currentTab",
    :compareDisabled= "compareDisabled",
    :hasCrowd="hasCrowd",
    :total= "total",
    :pg= "pg",
    :ps= "ps",
    :tablist= "tablist",
    :tableDataList= "tableDataList",
    :hasCheckBox= "hasCheckBox",
    :checkboxLength= "checkboxLength",
    :sumchecked="sumChecked",
    :sum= "sum",
    :order= "order",
    :legend= "legend", 
    :yAxis= "yAxis",
    :chartXAxis= "chartXAxis",
    :chartSeries= "chartSeries",
    @indiceChange= "indiceChange",
    @timeRangeChange="getDataWithCrowd",
    @tableUpdate= "updatePage",
    @tablesorter= "tablesorter",
    :customIndice= "customIndice",
    :twoIndiceShow= "twoIndiceShow",
    :twoIndice= "twoIndice")

    template(slot="tabview")
      ul.tab
        li.tab-item(v-for="item in tabViews")
          .tabview-btn(
                  @click.prevent="changeViewTo(item.comp)",
                  :class="{ active: currentView === item.comp}"
                ) {{item.title}}
    template(slot="crowd")
      CrowTags(v-show="currentView != 'externalLink'",
        :selectedCrowd="selectedCrowd",
        @showCrowd="showCrowd",
        @dropCrowd="dropCrowd",
        @openCrowd="openCrowd"
        )
    template(slot="crowd-content")
      CrowEditTemplate(v-if="crowdShow",
        :crowShowType="currentCrowdType",
        @updateCrowdList="getCrowdList",
        @updatePage="getTableData",
        @apply="applyCrowd",
        @reset="resetCrowd",
        @removeUpdate="removeUpdate",
        :crowdList="crowdList"
        )

    div.nav-tabs(slot="nav-tabs")
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab",
        :currentTab="currentTab")
        div.right-tab(slot="extentTab")
          DownloadBtn(
            :reportApi="reportApi",
            :params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0",
            style="float: right;")
          CustomIndice(
            :defaults="defaultCustomIndices",
            :hasSystemIndice="hasSystemIndice",
            @change="onCustomIndiceChange")
        div(slot="common") 
          p.plan-nav(v-show="sdimOptionShow")
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              :options="sdimOptions",
              @change.native="sdimChange")
          p.tabAction
            button.btn.btn-primary.btn-big(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData") 绘制选定行
            Search(
              v-show="currentView == 'externalLink'",
              :placeholder="placeHolder",
              @doSearch="doSearch",
              :defaultValue="keyword")
    v-select(
      slot="custom",
      v-show="transTypeShow",
      v-model="transelected",
      :options="transList",
      @input="transChangeWithCrowd()"
      )

  .report-content(v-show="calcLoading")
    .mask-panel
      img(src="https://p1.ssl.qhimg.com/t0173f568f185dc492d.gif")
  v-modal(:visible="isMv",
        ref="mvModal"
      )
      .modal-hd
        a.fa.fa-times.close(@click="isMv = false")
      .modal-bd
        p.text-content 使用该功能需要在网站部署360分析代码
        p.mv-container
          button.btn.btn-primary.btn-small.btn-mgr(@click="gotoSetting()") 去设置
  .guid
    .guid-mask(
      v-if="guidShow"
      )
        .guid-add(v-if="!createGuidShow && !systemGuidShow")
          img(src="https://p3.ssl.qhimg.com/t01b752e208c7f4c190.png")
          a.guid-close(
            @click="openSystemGuid"
          ) 知 道 啦
        .guid-create(v-if="createGuidShow")
          img(src="https://p5.ssl.qhimg.com/t01114bcfb959b5a1c1.png")
          a.guid-close(
            @click="removeGuid"
          ) 关 闭
        .guid-system(v-if="systemGuidShow")
          a.guid-close(
            @click="openCreateGuid"
            ) 知 道 啦
</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Mixin from '../mixin.js'
  import CrowdMixin from '../crowdmixin'
  import WebTemplate from './template'
  import CrowTags from './crowTags.vue'
  import CrowEditTemplate from './crowEditTemplate.vue'
  import CrowdTemplate from '../../component/crowdTemplate.vue'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    store: Store,
    components: {
      WebTemplate,
      CrowTags,
      CrowEditTemplate,
      CrowdTemplate
    },
    mixins: [Mixin, CrowdMixin],
    data () {
      return {
        guidEl: '',
        createGuidShow: false,
        systemGuidShow: false,
        guidShow: false,
        sumChecked: true,
        isMv: false,
        calcLoading: false,
        cacheVersion: '',
        timer: '',
        crowd: {},
        hasCrowd: true,
        crowdShow: false,
        selectedCrowd: [],
        crowdList: [],
        preview_crowdList: [],
        currentCrowdTab: 'system',
        currentCrowdType: 'list',
        placeHolder: '请输入链接',
        keyword: '',
        chartResList: [],
        hasCheckBox: true,
        checkboxLength: 3,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'reftype',
        isasc: 0,
        order: 'pv',
        legend: [],
        yAxis: [],
        currentView: 'all',
        tabViews: [
          {
            comp: 'all',
            title: '全部来源',
            tablist: [
              {
                id: 'reftype',
                name: '来源类型',
                order: 'pv',
                reportTableApi: '/api/report/reftype?pvtype=0&groupby=reftype',
                basicSummaryStatApi: '/api/report/reftype?pvtype=0&groupby=reftype&issum=1',
                reportLineChartApi: '/api/report/reftype?pvtype=0&groupby=reftype'
              },
              {
                id: 'refdomain',
                name: '来源网站',
                order: 'pv',
                reportTableApi: '/api/report/refdomain?groupby=refdomain',
                basicSummaryStatApi: '/api/report/refdomain?pvtype=0&groupby=refdomain&issum=1',
                reportLineChartApi: '/api/report/refdomain?pvtype=0&groupby=refdomain'
              }
            ]
          },
          {
            comp: 'searchEngine',
            title: '搜索引擎',
            tablist: [
              {
                id: 'refdomain',
                name: '搜索引擎',
                order: 'pv',
                reportTableApi: '/api/report/refdomain?pvtype=0&reftype=2&groupby=refdomain',
                basicSummaryStatApi: '/api/report/refdomain?pvtype=0&reftype=2&groupby=refdomain&issum=1',
                reportLineChartApi: '/api/report/refdomain?pvtype=0&reftype=2&groupby=refdomain'
              }
            ]
          },
          {
            comp: 'externalLink',
            title: '外部链接',
            tablist: [
              {
                id: 'refdomain',
                name: '链接域名',
                order: 'pv',
                reportTableApi: '/api/report/refdomain?pvtype=0&reftype=1&groupby=refdomain',
                basicSummaryStatApi: '/api/report/refdomain?pvtype=0&reftype=1&groupby=refdomain&issum=1',
                reportLineChartApi: '/api/report/refdomain?pvtype=0&reftype=1&groupby=refdomain'
              },
              {
                id: 'refurl',
                name: '全部链接',
                order: 'pv',
                reportTableApi: '/api/report/refurl?groupby=refurl',
                basicSummaryStatApi: '/api/report/refurl?groupby=refurl&issum=1',
                reportLineChartApi: '/api/report/refurl?groupby=refurl'
              }
            ]
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'pv',
        twoIndice: '',
        twoIndiceShow: true,
        sum: {},
        keyword: '',
        tableDataList: [],
        defaultCustomIndices: ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum'],
        sdimOptions: [],
        transelected: 'null',
        transList: [
          {
            label: '全部转化',
            value: 'null'
          }
        ],
        hasSystemIndice: true
      }
    },
    computed: {
      ...mapState('web', {
        tableIndices: state => state.tableIndices,
        compared: state => state.compared,
        compareStart: state => state.compareStart,
        compareEnd: state => state.compareEnd
      }),
      ...mapGetters('web', [
        'indicesMenu',
        'domainId',
        'uiError',
        'fetchLineChartabled',
        'twoIndiceSelectabled'
      ]),
      start () {
        return this.$store.state.start
      },
      end () {
        return this.$store.state.end
      },
      module () {
        return this.currentTab
      },
      clusterid () {
        return _.map(this.selectedCrowd, item => item.id).join(',')
      },
      cluster () {
        return _.map(this.selectedCrowd, item => item.name).join(',')
      },
      compareDisabled () {
        return this.selectedCrowd.length > 0
      },
      sdimOptionShow () {
        return this.currentTab === 'reftype' || this.currentView === 'searchEngine'
      },
      transTypeShow () {
        return this.currentView !== 'externalLink'
      },
      tablist () {
        return _.find(this.tabViews, {comp: this.currentView}).tablist
      },
      tableTabTitle () {
        return `${_.find(this.tablist, {id: this.currentTab}).name}报表`
      },
      query () {
        let query = {
          isasc: this.isasc,
          order: this.order,
          domainId: this.domainId,
          pvtype: 0,
          start: this.$store.state.start,
          end: this.$store.state.end,
          cycle: this.$store.state.start === this.$store.state.end ? 'hour' : 'day',
          timespan: new Date().getTime(),
          djid: this.dianjingID,
          mdim: this.currentTab
        }
        if (this.currentView !== 'externalLink' && this.clusterid) {
          query = _.assignIn({
            cache_version: this.cacheVersion,
            cluster: this.cluster,
            clusterid: this.clusterid,
            sdim: 'clusterid'
          }, query)
        }
        if (this.sdim !== 'null') {
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if (this.compared) {
          query = _.assignIn({
            compareStart: this.compareStart,
            compareEnd: this.compareEnd
          }, query)
        }
        if (this.currentView !== 'externalLink' && this.transelected !== 'null') {
          query = _.assignIn({
            tids: this.transelected
          }, query)
        }
        if (this.keyword) {
          query = _.assignIn({
            [this.currentTab]: this.keyword
          }, query)
        }
        return query
      },
      reportApi () {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    mounted () {
      if (!localStorage.__fx_origin_guid) {
        this.guidShow = true
        this.guidEl = document.querySelector('.guid')
        document.body.appendChild(this.guidEl)
        document.addEventListener('scroll', this.resizeMask)
      }
      this.transelected = 'null'
      this.fetchTransList()
    },
    watch: {
      crowdShow (newVal) {
        if (newVal) {
          this.preview_crowdList = _.cloneDeep(this.crowdList)
        }
      },
      crowdGroupTabs () {
        this.currentCrowdTab = this.crowdGroupTabs[0].key
      },
      sdimOptions (newVal) {
        if (!_.has(newVal[0], 'disabled')) {
          _.map(this.sdimOptions, item => {
            this.$set(item, 'disabled', this.selectedCrowd.length > 0)
            return item
          })
        }
      },
      selectedCrowd (newVal, oldVal) {
        _.map(this.sdimOptions, item => {
          this.$set(item, 'disabled', newVal.length > 0)
          return item
        })
        this.setHistoryCrowd()
      },
      domainId () {
        // 重置人群的相关信息
        this.calcLoading = false
        this.crowdShow = false
        clearInterval(this.timer)
        this.selectedCrowd = []
        this.clearKeyword()
        this.transelected = 'null'
        this.getTableData()
        this.fetchTransList()
        this.getCrowdList()
      },
      compared (newVal, oldVal) {
        this.compared = newVal
        this.resetIndice()
        if (newVal) {
          this.checkboxLength = 1
        } else {
          this.checkboxLength = 3
        }
      },
      uiError () {
        if (this.uiError.errMsg) {
          this.$Modal.warn(this.uiError.errMsg)
        }
        if (this.calcLoading) {
          this.calcLoading = false
        }
      }
    },
    methods: {
      ...mapActions('web', {
        setTableIndices: 'SET_TABLE_INDICES',
        setCompared: 'SET_COMPARED'
      }),
      removeGuid () {
        this.guidShow = false
        localStorage.__fx_origin_guid = true
      },
      openCreateGuid () {
        this.systemGuidShow = false
        this.createGuidShow = true
      },
      openSystemGuid () {
        this.openCrowd()
        this.systemGuidShow = true
      },
      resizeMask (e) {
        if (!this.guidShow) return
        const top = this.systemGuidShow ? 291 : this.createGuidShow ? 294 : 205
        const classname = this.systemGuidShow ? '.guid-system' : this.createGuidShow ? '.guid-create' : '.guid-add'
        const newTop = top - window.pageYOffset
        document.querySelector(classname).style.cssText = `top: ${newTop}px`
      },
      doSearch (keyword) {
        this.keyword = keyword
        this.getTableData()
      },
      transTypeName (key) {
        const transType = ['全部转化', '页面转化', '事件转化', '时长转化', '页数转化']
        return transType[key]
      },
      fetchTransList () {
        if (!this.domainId) return
        const translistPromise = this.$http.get('/api/trans/list', {
          params: {
            ps: 100,
            pg: 1,
            cycle: 'hour',
            domainId: this.domainId,
            timespan: new Date().getTime()
          }
        })
        this.$store.dispatch('VUE_HTTP', [translistPromise])
          .then((res) => {
            if (res) {
              const transList = _.groupBy(_.get(res, 'list'), 'type')
              const newTransList = [
                {
                  label: '全部转化',
                  value: 'null'
                }
              ]
              // 根据v-select所需options的格式进行修改
              _.forIn(transList, (value, key) => {
                newTransList.push({
                  label: this.transTypeName(key),
                  options: value.map(item => {
                    return {
                      value: item.id,
                      label: `${item.name}`
                    }
                  })
                })
              })
              this.transList = newTransList
            }
          })
      },
      changeViewTo (comp) {
        const view = _.find(this.tabViews, { comp })
        const activeTab = this.$store.state.paramsCrossPage.webOriginTab
        const currentTab = activeTab || view.tablist[0].id
        if (view) {
          if (this.currentView !== view.comp) {
            this.crowdShow = false
            this.currentView = view.comp
            this.sumChecked = this.currentView !== 'externalLink'
            this.updateTab(currentTab, true)
          }
        }
      },
      onCustomIndiceChange (indices) {
        this.setTableIndices(indices)
      },
      // 由于不同view中tab会相同，额外做处理
      tabChange () {
        this.sdim = 'null'
        this.keyword = ''
        this.order = _.find(this.tablist, {id: this.currentTab}).order
        this.isasc = 0
        this.resetTab(this.currentTab)
        this.resetIndice()
        // 重置人群数据
        if (this.calcLoading) {
          this.calcLoading = false
          clearInterval(this.timer)
        }
        // this.resetCrowd()
        if (this.currentView === 'externalLink') {
          this.getTableData()
        } else {
          this.getDataWithCrowd()
        }
      },
      updateTab (tab, forceUpdate) {
        if (this.currentTab === tab && !forceUpdate) return
        this.currentTab = tab
        // 全部链接没有系统指标
        if (tab === 'refurl') {
          this.hasSystemIndice = false
          this.defaultCustomIndices = ['pv', 'uv', 'ipnum', 'newvst', 'atime', 'tnum']
          this.setTableIndices(this.defaultCustomIndices)
        } else {
          this.hasSystemIndice = true
        }
        this.tabChange()
      }
    },
    created () {
      this.getHistoryCrowd()
      const activeView = this.$store.state.paramsCrossPage.webOriginView
      this.changeViewTo(activeView || 'all')
      this.setTableIndices(this.defaultCustomIndices)
    },
    destroyed () {
      this.guidEl && this.guidEl.remove()
      this.$store.commit('SET_CROSS_PARAM', {})
      clearInterval(this.timer)
      document.removeEventListener('scroll', this.resizeMask)
    }
  }
</script>
<style scoped>
.tab + .zone {
  border-top: 0;
}
.search {
  float: right;
}
.right-tab a {
  float: left;
}
.modal,
.modal-bd {
  min-width: 800px;
}
.mv-container {
  text-align: center;
}
p.text-content {
    text-align: center;
    font-size: 14px;
    margin: 0 0 40px;
}
.guid-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0, 0.4);
}
.guid-add {
  position: absolute;
  top: 205px;
  left: 212px;
}
.guid-close {
    background: rgba(0,0,0,0.4);
    color: #fff;
    display: inline-block;
    width: 80px;
    line-height: 35px;
    text-align: center;
    border: 1px solid rgba(255,255,255,0.7);
    border-radius: 20px;
    vertical-align: text-bottom;
    margin-left: 10px;
    word-spacing: 0;
}
.guid-system {
    position: absolute;
    left: 211px;
    right: 25px;
    top: 291px;
    height: 200px;
    box-sizing: content-box;
    border-width: 50px 150px 10px 800px;
    border-style: solid;
    border-image: url(https://p0.ssl.qhimg.com/t0118f0d2fd108d4e88.png) 50 150 10 800 repeat;
    background: url(https://p0.ssl.qhimg.com/t0118f0d2fd108d4e88.png) -350px -57px;
    background-clip: content-box;
    .guid-close {
      position: absolute;
      top: -57px;
    }
}
html[data-useragent*='MSIE 10.0'] .guid-system {
  border: 0;
  background-position: 0 0;
  height: 400px;
  background-repeat: no-repeat;
  .guid-close {
    top: -9px;
    left: 800px;
  }
}
.guid-create {
    position: absolute;
    top: 294px;
    left: 213px;
}
</style>




// WEBPACK FOOTER //
// origin.vue?ecdd85ae